<odin-page-container [attr.env]="envName" [attr.ver]="verNumber" [attr.env-md]="environment | json"></odin-page-container>
